module.exports = "<div class=\"flip-book-container\">\n\n</div>\n"